export default "__VITE_ASSET__DQIUXOcB__"